import { DEBUG } from "../boot/debug";
import { installPerfProbe } from "./perfProbe";

/** M44: imported first by main.ts so the debug probe wraps rAF, timers and listeners before any module makes one. */
if (DEBUG) installPerfProbe();
